export const removeHtmlTagsFromText = (str) => str.replace(/<[^>]*>/g, "");
